<div class="space-y-4">
    <!-- Filters Header -->
    <div class="flex flex-col md:flex-row gap-4 justify-between items-center mb-6">
        <div class="flex flex-col md:flex-row gap-4 w-full md:w-auto">
            <!-- Search -->
            <p-iconfield>
                <p-inputicon class="pi pi-search" />
                <input type="text" pInputText [(ngModel)]="searchText" (input)="onSearch()"
                    [placeholder]="'professionals_search' | translate" class="w-full md:w-80" />
            </p-iconfield>

            <!-- Date range -->
            <div class="flex items-center gap-2 w-full md:w-auto">
                <p-datepicker [(ngModel)]="startDate" (onSelect)="onDateChange()"
                    [placeholder]="'professionals_date_start' | translate" [showIcon]="true" styleClass="w-full md:w-40"
                    [inputStyle]="{'width':'100%'}" class="flex-1">
                </p-datepicker>
                <span class="text-slate-400 shrink-0">{{ 'to' | translate }}</span>
                <p-datepicker [(ngModel)]="endDate" (onSelect)="onDateChange()"
                    [placeholder]="'professionals_date_end' | translate" [showIcon]="true" styleClass="w-full md:w-40"
                    [inputStyle]="{'width':'100%'}" class="flex-1">
                </p-datepicker>
            </div>
        </div>

        <div class="flex gap-3 w-full md:w-auto">
            <app-button *ngIf="searchText || startDate || endDate" [label]="'CLEAR_FILTERS' | translate"
                (onClick)="clearFilters()" variant="secondary">
            </app-button>
            <app-button *hasPermission="'Profissionais:create'" [label]="'professionals_new_shift' | translate" icon="pi pi-plus" (onClick)="onNewShift()">
            </app-button>
        </div>
    </div>

    <!-- Main Table Section -->
    <div class="border border-slate-200 rounded-xl overflow-hidden bg-white shadow-sm h-[600px]">
        <app-prime-table [columns]="cols" [data]="shifts" [loading]="loading" [totalRecords]="totalRecords"
            [rows]="pageSize" [lazy]="true" (onPage)="onPageChange($event)" [templates]="templates" scrollHeight="flex"
            [scrollable]="true" [paginator]="true">
        </app-prime-table>
    </div>

    <!-- Templates -->
    <ng-template #doctor_name let-row>
        <div class="flex items-center gap-3">
            <div class="w-8 h-8 rounded-full overflow-hidden bg-slate-100 flex-shrink-0 flex items-center justify-center bg-no-repeat bg-center bg-cover"
                [style.background-image]="'url(assets/images/user-profile.png)'">
                <img *ngIf="row.doctor_image" [src]="row.doctor_image" (error)="row.doctor_image = null"
                    class="w-full h-full object-cover" />
            </div>
            <span class="font-medium text-slate-700">{{ row.doctor_name || '-' }}</span>
        </div>
    </ng-template>

    <ng-template #date_cell let-row let-col="col">
        <span class="text-slate-600">{{ formatDate(row[col.field]) }}</span>
    </ng-template>

    <ng-template #time_cell let-row let-col="col">
        <span class="text-slate-600">{{ formatTime(row[col.field]) }}</span>
    </ng-template>

    <ng-template #duration_cell let-row>
        <span class="text-slate-600">{{ row.duration }} m</span>
    </ng-template>

    <ng-template #shiftActions let-row>
        <app-dropdown>
            <ng-template #trigger>
                <button class="p-2 text-slate-400 hover:text-primary hover:bg-primary/5 rounded-xl transition-all">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        <path
                            d="M12 8a2 2 0 100-4 2 2 0 000 4zM12 14a2 2 0 100-4 2 2 0 000 4zM12 20a2 2 0 100-4 2 2 0 000 4z" />
                    </svg>
                </button>
            </ng-template>
            <ng-template #content>
                <div class="flex flex-col min-w-[160px]">
                    <button *hasPermission="'Profissionais:edit'" (click)="onEdit(row)"
                        class="w-full text-left px-4 py-3 text-[10px] font-black uppercase tracking-widest text-slate-600 hover:bg-slate-50 flex items-center gap-3 transition-colors">
                        <i class="pi pi-pencil text-primary"></i>
                        {{ 'EDIT' | translate }}
                    </button>
                    <button *hasPermission="'Profissionais:delete'" (click)="onDelete(row)"
                        class="w-full text-left px-4 py-3 text-[10px] font-black uppercase tracking-widest text-rose-600 hover:bg-rose-50 flex items-center gap-3 transition-colors">
                        <i class="pi pi-trash"></i>
                        {{ 'DELETE' | translate }}
                    </button>
                </div>
            </ng-template>
        </app-dropdown>
    </ng-template>
</div>